import React, { useContext } from 'react'
import { css } from '@emotion/core'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { SettingsLayout } from '@/components/layouts/settings-layout'
import { InputField } from '@/components/molecules/input-field'
import { DeviceSettingsFooter } from '@/components/organisms/settings/device-settings-footer'
import { CheckinTabContainer } from '@/components/organisms/settings/checkin-tab-container'
import { TabContainer } from '@/components/organisms/settings/tab-container'
import { AccountContext } from '@/contexts/account'
import { useTerminalSetting } from '@/hooks/self-checkin-device-settings/use-terminal-setting'

export const SelfCheckinTerminal: React.FC = () => {
  const { t } = useTranslation()
  const { account } = useContext<any>(AccountContext)
  const hotelId: string = account?.hotel?.id || account?.employee?.hotelId || ''
  const { control, isDirty, isLoading, canTestConnection, testConnection, save, cancel } = useTerminalSetting(hotelId)
  const footerContent = (
    <DeviceSettingsFooter isDirty={isDirty} onSave={save} onCancel={cancel} onTest={testConnection} isTestDisabled={!canTestConnection} />
  )

  return (
    <SettingsLayout loading={isLoading} footerContent={footerContent}>
      <TabContainer tabComponent={<CheckinTabContainer currentTab="Terminal" />} isShowFooter>
        <div css={containerStyle}>
          <div css={fieldStyle}>
            <div className="input-label">{t('IP Address of terminal')}</div>
            <Controller
              control={control}
              name="terminalIp"
              render={({ field: { onChange, value } }) => <InputField value={value} handleChangeData={onChange} placeholder="127.0.0.1" />}
            />
          </div>
          <div css={fieldStyle}>
            <div className="input-label">{t('Port of terminal')}</div>
            <Controller
              control={control}
              name="terminalPort"
              render={({ field: { onChange, value } }) => <InputField value={value} handleChangeData={onChange} placeholder="3647" />}
            />
          </div>
        </div>
      </TabContainer>
    </SettingsLayout>
  )
}

const containerStyle = css({
  padding: 32,
  '.input-label': {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 12,
  },
})

const fieldStyle = css({ width: 300 })
